/*eslint-disable */
import root from '../_helpers/roots';
let roomCreateURL = root.roomCreateUrl.link;
import axios from 'axios';
import Vue from 'vue'
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    apiUserRoomCreateForChatFunction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(roomCreateURL, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
  }
}